import { call, takeLatest, put } from "redux-saga/effects"
import { requestCurrentUser, requestvalidRedirectUrl } from "appRedux/sagas/requests/currentUser"
import { getCurrentUser, setCurrentUser, getValidRedirectUrls, getValidRedirectUrlsSuccess } from "appRedux/slices/currentUser"
import { fetchError } from "appRedux/slices/common"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

function* handleGetCurrentUser(params) {
  try {
    const data = yield call(requestCurrentUser, params)
    yield put(setCurrentUser(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handlevalidRedirectUrl(params) {
  try {
    const data = yield call(requestvalidRedirectUrl, params)
    yield put(getValidRedirectUrlsSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

export default function* watcherSaga() {
  yield takeLatest(getCurrentUser.type, handleGetCurrentUser)
  yield takeLatest(getValidRedirectUrls.type, handlevalidRedirectUrl)
}
